module.exports = __webpack_public_path__ + "img/buy-icon6.08ee895.png";